import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Spinner, StatefulButton } from '@edx/paragon';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import PasswordSelection from './components/PasswordSelection';
import { validateToken } from './data/actions';
import {
  PASSWORD_RESET_ERROR,
  PASSWORD_VALIDATION_ERROR,
  RESET_STATE,
  TOKEN_STATE,
} from './data/constants';
import { resetPasswordResultSelector } from './data/selectors';
import messages from './messages';
import { PasswordChangedSVG } from '../assets/svgs';
import Decorations from '../common-components/Decorations';
import Popup from '../common-components/Popup';
import ResetPasswordStepsTabs from '../common-components/ResetPasswordStepsTabs';
import { LOGIN_PAGE, RESET_PAGE } from '../data/constants';
import { updatePathWithQueryParams } from '../data/utils';
import loginMessages from '../login/messages';

const ResetPasswordPage = (props) => {
  const { formatMessage } = useIntl();

  const newPasswordError = formatMessage(messages['password.validation.message']);

  const [errorCode, setErrorCode] = useState(null);
  const [formErrors, setFormErrors] = useState({
    newPassword: '',
    confirmPassword: '',
  });

  const navigate = useNavigate();

  const { token } = useParams();

  useEffect(() => {
    if (token && props.status === TOKEN_STATE.PENDING) {
      props.validateToken(token);
    }
    if (props.status !== TOKEN_STATE.PENDING && props.status !== PASSWORD_RESET_ERROR) {
      setErrorCode(props.status);
    }
    if (props.status === PASSWORD_VALIDATION_ERROR) {
      setFormErrors({ newPassword: newPasswordError });
    }
  }, [props, token, newPasswordError, navigate]);

  if (token && props.status === TOKEN_STATE.PENDING) {
    return <Spinner animation="border" variant="primary" className="spinner--position-centered" />;
  }
  if (props.status === PASSWORD_RESET_ERROR) {
    return <Navigate to={updatePathWithQueryParams(RESET_PAGE)} />;
  }
  return (
    <>
      <Helmet>
        <title>
          {formatMessage(messages['reset.password.page.title'], { siteName: getConfig().SITE_NAME })}
        </title>
      </Helmet>
      <div id="main-content" className="reset-password-page h-100 d-flex align-items-center flex-column flex-fill">
        {/* <ResetPasswordFailure errorCode={errorCode} errorMsg={props.errorMsg} /> */}
        <div className="p-6 d-flex flex-column flex-fill">
          <ResetPasswordStepsTabs step={1} />
          <PasswordSelection
            errorCode={errorCode}
            setErrorCode={setErrorCode}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
            resetStatus={props.resetStatus}
          />
        </div>
        {props.resetStatus === RESET_STATE.SUCCESS && (
          <Popup onClose={() => {}}>
            <div className="flex-center-column gap-40" data-gtm="reset-password-success">
              <img src={PasswordChangedSVG} alt="password-changed" />
              <h1 style={{ fontSize: 28, fontWeight: 800 }}>
                {formatMessage(messages['password.changed.popup.title'])}
              </h1>
              <StatefulButton
                type="submit"
                className="logistration-btn"
                labels={{
                  default: formatMessage(loginMessages['login.page.button.text']),
                  pending: '',
                }}
                onClick={() => navigate(LOGIN_PAGE)}
              />
            </div>
          </Popup>
        )}
        <Decorations />
      </div>
    </>
  );
};

ResetPasswordPage.defaultProps = {
  status: null,
  resetStatus: RESET_STATE.DEFAULT,
  // errorMsg: null,
};

ResetPasswordPage.propTypes = {
  validateToken: PropTypes.func.isRequired,
  status: PropTypes.string,
  resetStatus: PropTypes.string,
  // errorMsg: PropTypes.string,
};

export default connect(
  resetPasswordResultSelector,
  {
    validateToken,
  },
)(ResetPasswordPage);
